export default "__VITE_ASSET__Bs9fblpp__"